import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { fieldFilter } from '../FieldFilter';
import { categoryFilter } from '../CategoryFilter';
import { product } from '../Product';
export const productSearchNewRequest = z
    .object({
        minPrice: z.number().int().optional(),
        maxPrice: z.number().int().optional(),
        maxDiscountedPercentage: z.number().optional(),
        minDiscountedPercentage: z.number().optional(),
        withAllTags: z.array(z.string()).optional(),
        withSomeTags: z.array(z.string()).optional(),
        withNoneTags: z.array(z.string()).optional(),
        pageSize: z.number().int().positive().max(50),
        sortBy: z.enum(['relevance', 'price-asc', 'price-desc'])
    })
    .strict();

export const productSearchNewResult = z
    .object({
        totalQuantity: z.number().int().nonnegative(),
        minPrice: z.number().int().optional(),
        maxPrice: z.number().int().optional(),
        products: z.array(product),
        suggestedProducts: z.array(product),
        availableFieldFilters: z.array(fieldFilter),
        availableCategoryFilters: z.array(categoryFilter),
        suggestedFieldFilters: z.array(fieldFilter),
        suggestedCategoryFilters: z.array(categoryFilter)
    })
    .strict();

export const productSearchNew = {
    verb: 'post',
    path: 'search-new',
    schema: {
        body: productSearchNewRequest,
        response: { 200: productSearchNewResult }
    }
} as const satisfies EndpointContract;

export type ProductSearchNewResult = z.infer<typeof productSearchNewResult>;
